import React from "react";
import logo from "../logo/Logo.png";
import { Link } from "react-router-dom";

const PrivacyPolicy = ({ show, handleClose }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-3xl mx-4 my-2">
        <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200">
         
                          <Link to="/" className="no-underline group relative inline-block h-[40px] w-[200px]">
                              <img src={logo} alt="logo" className="h-[40px]" />
                              <span className="absolute top-1/2 ml-4 mt-1 transform -translate-y-1/2 text-xl font-bold text-green-700 pointer-events-none">
                                manaChoice
                              </span>
                          </Link>
         
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            &times;
          </button>
        </div>

        <div className="px-6 py-2 text-gray-700 max-h-[70vh] overflow-y-auto text-sm leading-relaxed">
          <h2 className="text-xl font-bold mb-2">Privacy Policy</h2>
          <p className="mb-4">
            This Privacy Policy explains how manaChoice ("we", "us", or "our") collects,
            uses, and discloses information about you when you use our mobile application
            (the "App") and the services offered through the App.
          </p>

          <div className="space-y-5">
            <section>
              <h3 className="font-semibold text-base text-gray-800 mb-1">Information We Collect</h3>
              <ul className="list-disc list-inside space-y-1">
                <li>
                  When you register as a seller or buyer, we collect your name, phone number, and address.
                </li>
                <li>
                  If you make a purchase, we collect order details and payment information.
                </li>
                <li>
                  We may collect any other information you choose to provide, such as feedback.
                </li>
                <li>
                  With your consent, we may access your device's camera for uploading item photos.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="font-semibold text-base text-gray-800 mb-1">How We Use Your Information</h3>
              <ul className="list-disc list-inside space-y-1">
                <li>To provide and improve the App and our services.</li>
                <li>To process transactions and fulfill orders.</li>
                <li>To communicate with you and offer customer support.</li>
                <li>To personalize your experience on the App.</li>
                <li>To detect and prevent fraud and abuse.</li>
                <li>To enable features like photo uploads via the device's camera.</li>
              </ul>
            </section>

            <section>
              <h3 className="font-semibold text-base text-gray-800 mb-1">How We Share Your Information</h3>
              <ul className="list-disc list-inside space-y-1">
                <li>
                  <strong>Sellers:</strong> To facilitate transactions and fulfill orders.
                </li>
                <li>
                  <strong>Service Providers:</strong> Such as payment processors and analytics tools.
                </li>
                <li>
                  <strong>Business Transfers:</strong> In the case of a merger, acquisition, or asset sale.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="font-semibold text-base text-gray-800 mb-1">Your Choices</h3>
              <p>
                You can choose not to provide certain information, but this may limit your ability
                to use some features. You can also manage collection preferences in device settings.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base text-gray-800 mb-1">Data Security</h3>
              <p>
                We take reasonable steps to protect your data. However, no method of transmission or storage is
                completely secure.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base text-gray-800 mb-1">Accessing Your Information</h3>
              <p>
                You may access, update, or delete your data by contacting us. We may retain certain info
                for legal or business purposes.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base text-gray-800 mb-1">Changes to this Privacy Policy</h3>
              <p>
                We may update this Privacy Policy occasionally. Major updates will be communicated via email or in-app notifications.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-base text-gray-800 mb-1">Contact Us</h3>
              <p>
                For questions or concerns, please reach out at{" "}
                <a
                  href="mailto:contact@manaChoice1493@gmail.com"
                  className="text-green-700 hover:underline"
                >
                  contact@manaChoice1493@gmail.com
                </a>
                .
              </p>
            </section>
          </div>
        </div>

        <div className="flex justify-end px-6 py-2 border-t border-gray-200 space-x-3">
          <button
            onClick={handleClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
